import WhatsAppSipHolidaysAPI from 'dashboard/api/whatsappSip/holidays';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const getters = {
  getRecords: $state => $state.records,
  getNationalHolidays: $state => $state.records.filter(r => r.account_id === 0),
  getMunicipalHolidays: $state =>
    $state.records.filter(r => r.account_id !== 0),
  getUIFlags: $state => $state.uiFlags,
};

const actions = {
  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await WhatsAppSipHolidaysAPI.get();
      commit('SET_RECORDS', data.holidays || []);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async create({ commit }, holidayData) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await WhatsAppSipHolidaysAPI.create(holidayData);
      const holiday = data.holiday || data;
      commit('ADD_RECORD', holiday);
      return holiday;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, data: updateData }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await WhatsAppSipHolidaysAPI.update(id, updateData);
      const holiday = data.holiday || data;
      commit('UPDATE_RECORD', holiday);
      return holiday;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await WhatsAppSipHolidaysAPI.delete(id);
      commit('DELETE_RECORD', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
};

const mutations = {
  SET_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  SET_RECORDS($state, records) {
    $state.records = records;
  },
  ADD_RECORD($state, record) {
    $state.records = [record, ...$state.records];
  },
  UPDATE_RECORD($state, record) {
    const index = $state.records.findIndex(r => r.id === record.id);
    if (index !== -1) {
      $state.records.splice(index, 1, { ...$state.records[index], ...record });
    }
  },
  DELETE_RECORD($state, id) {
    $state.records = $state.records.filter(r => r.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
